import { safeReturnRoute, type MiraRouteId } from '@mira/clients-shared';
import { hrefForRoute } from '../app/router.js';
import { MiraIcon } from '../ui/primitives/index.js';

export function sourceBackHref(from: MiraRouteId, source?: MiraRouteId, returnTo?: string | null): string {
  if (returnTo) return returnTo.startsWith('#') ? returnTo : `#${returnTo}`;
  return hrefForRoute(safeReturnRoute(from, source));
}

export function SourceBackButton(props: { from: MiraRouteId; source?: MiraRouteId; returnTo?: string | null; label?: string }) {
  return (
    <a className="mira-icon-button" href={sourceBackHref(props.from, props.source, props.returnTo)} aria-label={props.label || 'Back'}>
      <MiraIcon name="action.back" />
    </a>
  );
}
